import BasketPaxSFC from "./BasketPax.vue";
export const BasketPax = BasketPaxSFC;
